import { render, staticRenderFns } from "./StoryCampaignGridItem.vue?vue&type=template&id=21023975&scoped=true&"
import script from "./StoryCampaignGridItem.vue?vue&type=script&lang=js&"
export * from "./StoryCampaignGridItem.vue?vue&type=script&lang=js&"
import style0 from "./StoryCampaignGridItem.vue?vue&type=style&index=0&id=21023975&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21023975",
  null
  
)

export default component.exports